import { gql } from "@apollo/client";
import { client } from "..";

const insertGogasUser = gql`
mutation InsertCNGUsers($objects: [gogas_cng_users_insert_input!] = {}) {
  insert_gogas_cng_users(objects: $objects) {
    affected_rows
  }
}
`

export const CreateCNGUser = async (
    data, mtoken
) => {
    let resp;
    const value = {
        "name": data?.name,
        "phone_number": data?.mobile,
        "station_name": data?.station_name,
        "city": data?.city,
        "state": data?.state,
        "erp_code": data?.erp_code,
        "staff_number": data?.sales_name,
        "vehicle_number": data?.vehicleNumber,
        "vehicle_type": data?.vehicle_type
    }
    try {
        resp = await client.mutate({
            mutation: insertGogasUser,
            refetchQueries: [],
            variables: { "objects": [value] },
            context: {
                headers: {
                    "Content-Type": "application/json",
                    authorization:
                        `Bearer ${mtoken}`,
                },
            },
        });
        if (resp.errors) {
            console.log(resp.errors)
            // message.error(resp.errors);
            return resp.errors
        }
        // window.location.reload();
    } catch (e) {
        console.log(JSON.stringify(e));
    }
    // message.success(`Product ${data?.name} Created Successfully!'`, 5);
    return resp;
};